import script from "./CenikTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./CenikTitle.vue?vue&type=script&setup=true&lang=ts"

import "./CenikTitle.vue?vue&type=style&index=0&id=165d9c68&lang=scss&scoped=true"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165d9c68"]])

export default __exports__